import { DetectBrand } from "../../mixins/brandDetector";
const brandedStore = {
  //MenuDoc: "Menus/{0}/StoreMenus/DefaultMenu",
  StoreMenuDoc: "Menus/{0}/StoreMenus/{1}",
  StoreMenus: "Menus/{0}/StoreMenus/",
  MenuDoc: "Menus/{0}/",
  StoreCollection: "Stores",
  UserDoc: "Users/{0}",
  GuestUserDoc: "GuestUsers",
  HistoryOrdersCollection: "OnlineOrdersInfo/{0}/HistoryOrders/",
  TrackingOrderDoc: "OnlineOrdersInfo/{0}/TrackingOrders/{1}",
  TrackingOrderCollection: "OnlineOrdersInfo/{0}/TrackingOrders/",
  BasicDoc: "BasicInformation/Basic",
  MessageTemplateCollection: "Stores/{0}/MessageTemplates",
  PriceTriggersDoc: "Menus"
};
const generalStore = {
  StoreMenus: "OnlineOrderingModule/{0}/Menus/",
  MenuDoc: "OnlineOrderingModule/{0}/",
  StoreCollection: "OnlineOrderingModule",
  UserDoc: "Users/{0}",
  GuestUserDoc: "OnlineOrderingModule/{0}/GuestUsers/",
  HistoryOrdersCollection: "OnlineOrderingModule/{0}/HistoryOrders/",
  TrackingOrderCollection: "OnlineOrderingModule/{0}/TrackingOrders/",
  TrackingOrderDoc: "?",
  PriceTriggersDoc: "OnlineOrderingModule/{0}/Menus/",
  BasicDoc: "",
  MessageTemplateCollection: "?"
};

export const paths = DetectBrand.methods.isBranded()
  ? brandedStore
  : generalStore;
